import { Autocomplete, Box, Modal, TextField } from "@mui/material";
import { Theme } from "@mui/material/styles";
import { SxProps } from '@mui/system';
import { FC, useEffect, useState } from "react";
import { ICostCategoriesMap, IInputSuggestionsList } from "../../../../reducer/mappingFiles/_interfaces";
import { useDispatch, useSelector } from "react-redux";
import { inputSuggestions, ikaMapCountries } from "../../../../reducer/mappingFiles/selectors";
import * as constants from "../constants";
import { saveItem } from "../../../../actions/CostCategoriesMapping/ikamapActions";


type IProps = {
    open:boolean;
    selectedItem?:ICostCategoriesMap | null;
    toggleOpen: () => void;
}


const style: SxProps<Theme> = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '87vw',
    height: '94vh',
    bgcolor: 'background.paper',
    border: '2px solid FFFFFF',
    boxShadow: 24,
    borderRadius: 8,
    p: '1.5vh 3vh',
}

export const EditModal:FC<IProps> = ({open, toggleOpen, selectedItem}) => {
    const dispatch = useDispatch();
    const filters:IInputSuggestionsList = useSelector(inputSuggestions);

    const [CeGroupLevel1, setCeGroupLevel1] = useState<string>(selectedItem?.ce_group_level_1 || '');
    const [CeGroupLevel2, setCeGroupLevel2] = useState<string>(selectedItem?.ce_group_level_2 || '');
    const [CeGroupLevel3, setCeGroupLevel3] = useState<string>(selectedItem?.ce_group_level_3 || '');
    const [GlAccount, setGlAccount] = useState<string>(selectedItem?.gl_account || '');
    const [GlAccountDescription, setGlAccountDescription] = useState<string>(selectedItem?.gl_account_description || '');
    const [Mix, setMix] = useState<string>(selectedItem?.mix || '');
    const [reason, setReason] = useState<string>(selectedItem?.reason || '');


    useEffect(() => {
        setCeGroupLevel1(selectedItem?.ce_group_level_1 || '');
        setCeGroupLevel2(selectedItem?.ce_group_level_2 || '');
        setCeGroupLevel3(selectedItem?.ce_group_level_3 || '');
        setGlAccount(selectedItem?.gl_account || '');
        setGlAccountDescription(selectedItem?.gl_account_description || '');
        setMix(selectedItem?.mix || '');
        setReason(selectedItem?.reason || '');
    }, [selectedItem, open]);

    const submitForm = () => {
        if ( Mix && CeGroupLevel1 && CeGroupLevel2 && CeGroupLevel3 && GlAccount && GlAccountDescription) {
            const item = {
                id: selectedItem?.id || null,
                ce_group_level_1: CeGroupLevel1,
                ce_group_level_2: CeGroupLevel2,
                ce_group_level_3: CeGroupLevel3,
                gl_account: GlAccount,
                gl_account_description: GlAccountDescription,
                mix: Mix,
                reason,
            }

            toggleOpen();
            dispatch(saveItem(item, 'formmap'));
        }
    }

    return (
        <Modal
            open={open}
            onClose={toggleOpen}
            onBackdropClick={toggleOpen}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <Box sx={style}>
                <div className="brand-category-modal-form-header">
                    <p>
                        {selectedItem
                            ?  `Cust. Planning Level: ${selectedItem.ce_group_level_1}`
                            : "Add New Entry"}
                    </p>
                    <div className="brand-category-modal-form-close-button" onClick={toggleOpen}>
                        X
                    </div>
                </div>
                <div className="brand-category-modal-form-body">
                    <div className="brand-category-modal-form-input-container row m-0">
                        <div className="d-grid" style={{
                            gridTemplateColumns: "repeat(3, 1fr)",
                            gap: 16
                        }}>
                            
                            <div className="brand-category-modal-form-input col-3 p-0 w-100">
                                <div style={{ display: "flex" }}>
                                    <p className="m-0 mb-2">{constants.ce_group_level_1_label}</p><p style={{ color: "#E61C2A" }}>*</p>
                                </div>
                                {/* <Autocomplete
                                    id="country"
                                    autoHighlight
                                    onChange={(event, newValue) => setSelectedCountry(newValue)}
                                    value={selectedCountry}
                                    options={countries}
                                    getOptionLabel={(option:ICountry) => option.title}
                                    renderInput={(params) => <TextField {...params} />}
                                /> */}
                                <TextField id="CE Group Level 1" onChange={(event) => {setCeGroupLevel1(event.target.value)}} value={CeGroupLevel1}/>

                            </div>

                            <div className="brand-category-modal-form-input col-3 p-0 w-100">
                                <div style={{ display: "flex" }}>
                                    <p className="m-0 mb-2">{constants.ce_group_level_2_label}</p><p style={{ color: "#E61C2A" }}>*</p>
                                </div>
                                {/* <Autocomplete
                                    id="cust_planning_level"
                                    freeSolo
                                    onInputChange={(event, newInputValue) => setCustPlanningLevel(newInputValue)}
                                    value={custPlanningLevel}
                                    options={filters.cust_planning_level.map(({title}) => (title))}
                                    renderInput={(params) => <TextField {...params} />}
                                /> */}
                                <TextField id="CE Group Level 2" onChange={(event) => {setCeGroupLevel2(event.target.value)}} value={CeGroupLevel2}/>

                            </div>

                            
                            <div className="brand-category-modal-form-input col-3 p-0 w-100">
                                <div style={{ display: "flex" }}>
                                    <p className="m-0  mb-2">{constants.ce_group_level_3_label}</p><p style={{ color: "#E61C2A" }}>*</p>
                                </div>
                                {/* <Autocomplete
                                    id="cust_planning_level_name"
                                    freeSolo
                                    onInputChange={(event, newInputValue) => setCustPlanningLevelName(newInputValue)}
                                    value={custPlanningLevelName}
                                    options={filters.cust_planning_level_name.map(({title}) => (title))}
                                    renderInput={(params) => <TextField {...params} />}
                                /> */}

                                <TextField id="CE Group Level 3" onChange={(event) => {setCeGroupLevel3(event.target.value)}} value={CeGroupLevel3}/>
                            </div>

                            
                            <div className="brand-category-modal-form-input col-3 p-0 w-100">
                                <div style={{ display: "flex" }}>
                                    <p className="m-0 mb-2">{constants.gl_account_label}</p><p style={{ color: "#E61C2A" }}>*</p>
                                </div>
                                {/* <Autocomplete
                                    id="gkc"
                                    freeSolo
                                    onInputChange={(event, newInputValue) => setGkc(newInputValue)}
                                    value={gkc}
                                    options={filters.gkc.map(({title}) => (title))}
                                    renderInput={(params) => <TextField {...params} />}
                                /> */}

                                <TextField type='number' id="Gl Account" onChange={(event) => {setGlAccount(event.target.value)}} value={GlAccount}/>

                            </div>

                            
                            <div className="brand-category-modal-form-input col-3 p-0 w-100">
                                <div style={{ display: "flex" }}>
                                    <p className="m-0 mb-2">{constants.gl_account_description_label}</p><p style={{ color: "#E61C2A" }}>*</p>
                                </div>
                                {/* <Autocomplete
                                    id="buyng_group_cust_name"
                                    freeSolo
                                    onInputChange={(event, newInputValue) => setBuyngGroupCustName(newInputValue)}
                                    value={buyngGroupCustName}
                                    options={filters.buyng_group_cust_name.map(({title}) => (title))}
                                    renderInput={(params) => <TextField {...params} />}
                                /> */}

                                <TextField id="Gl Account Description" onChange={(event) => {setGlAccountDescription(event.target.value)}} value={GlAccountDescription}/>

                            </div>
                            <div className="brand-category-modal-form-input col-3 p-0 w-100">
                                <div style={{ display: "flex" }}>
                                    <p className="m-0 mb-2">{constants.mix_label}</p><p style={{ color: "#E61C2A" }}>*</p>
                                </div>
                                {/* <Autocomplete
                                    id="buyng_group_cust_name"
                                    freeSolo
                                    onInputChange={(event, newInputValue) => setBuyngGroupCustName(newInputValue)}
                                    value={buyngGroupCustName}
                                    options={filters.buyng_group_cust_name.map(({title}) => (title))}
                                    renderInput={(params) => <TextField {...params} />}
                                /> */}

                                <TextField id="Mix" onChange={(event) => {setMix(event.target.value)}} value={Mix}/>

                            </div>
                        </div>
                    </div>
                </div>

                <div className="brand-category-modal-form-footer row m-0">
                    <div className="brand-category-modal-form-input col-6">
                        <div style={{ display: "flex" }}>
                            <p className="m-0">Comment</p><p style={{ color: "#E61C2A" }}>*</p>
                        </div>

                        <textarea className="brand-category-text-input-box"
                            style={{ width: "100%" }}
                            rows={4} cols={50}
                            name="reason"
                            value={reason}
                            onChange={(e) => setReason(e.target.value)}
                        />
                    </div>
                    <div className="brand-category-modal-form-input col-6">
                        <div style={{ float: "right" }}>
                            <button className="brand-category-form-modal-cancel-button mt-3" onClick={toggleOpen}>Cancel</button>
                            <button className="brand-category-form-modal-submit-button mt-3" onClick={submitForm}>Submit</button>
                        </div>
                    </div>

                </div>
            </Box>
        </Modal>
    );
}